// extracted by mini-css-extract-plugin
module.exports = {"charity-tile-logo":"charity_card__charity-tile-logo___2lIl-","charity-wrap":"charity_card__charity-wrap___17lpB","charity-title":"charity_card__charity-title___3dBaB"};